module.exports = new __parcel__URL__("Warriorskill_13.a4e52990.png").toString();